<div class="modal fade group-class-save " id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog real-attendance-save">
        <div class="modal-content">
            <div class="modal-body">
                <div class="modal-header p-0 align-items-center">
                    <span class="pl-4 register-attendees" *ngIf="!isRealAttendanceEdit"
                        translate>GroupClassDetails.RealAttendanceRegisterHeader</span>
                    <span class="pl-4 register-attendees" *ngIf="isRealAttendanceEdit"
                        translate>GroupClassDetails.RealAttendanceEditHeader</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="container mt-2 pl-4 text-bayclub-blue">
                    <bcu-local-spinner [size]="25" [visible]="!isLoaded" *ngIf="!isLoaded"></bcu-local-spinner>
                    <form [formGroup]="form" *ngIf="isLoaded">
                        <div class="row">
                            <div class="col">
                                <div class="circle">
                                    <app-group-classes-category-icon [category]="model.category.code"
                                        [status]="model.status.code"></app-group-classes-category-icon>
                                </div>
                                <strong> {{ model.category.name }}</strong>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <div class="text-uppercase">
                                    <strong>{{ model.name }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                {{ model.club.shortName }} <span *ngIf="model.location"> |
                                    {{ model.location.name }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div>
                                    {{ model.date | bcDate: 'MMM DD' }} &#64;
                                    {{ model.timeFromInMinutes | timeDisplay }} -
                                    {{ model.timeToInMinutes | timeDisplay }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <span translate>GroupClassDetails.InstructorLabel</span>
                                <app-instructor-label [nominalInstructor]="model.instructor"
                                    [substituteInstructor]="model.substituteInstructor"></app-instructor-label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-7 form-group register-attendees-label mt-3">
                                <label for="realAttendance" translate>GroupClassDetails.RealAttendanceHowMany</label>
                                <input class="form-control attendance-input" type="number" id="realAttendance" min="0"
                                    numbersOnly="9999" formControlName="realAttendance" />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer p-0 align-items-center justify-content-end" *ngIf="isLoaded">
                    <button class="btn bc-button mr-1 my-3" (click)="onClose()" translate>Cancel</button>
                    <button class="btn btn-success ml-1 my-3 mr-3" (click)="onSave()" translate>Save</button>
                </div>
            </div>
        </div>
    </div>
</div>